import "../../assets/styles/component/page404.css";

const Page404 = () => {
  return (
    <div id="page-404">
      <div className="title-404-cont">
        <div className="title-404-text-cont">
          <p className="title-404-text">4</p>
          <p className="symbol-text">{"</>"}</p>
          <p className="title-404-text">4</p>
        </div>
        <div className="content-404-cont">
          <div className="error-text-cont">
            <p className="error-text">Error404</p>
            <p className="symbol-text">{"(){"}</p>
          </div>
          <div className="message-text-cont">
            {" "}
            &emsp;
            <p className="message-text">message</p>&nbsp;
            <p className="symbol-text">= "</p>
            <p className="page-not-found">page not found</p>
            <p className="symbol-text">";</p>
          </div>
          <div className="message-text-cont">
            {" "}
            &emsp;
            <p className="message-text">product</p>&nbsp;
            <p className="symbol-text">= "</p>
            <p className="page-not-found">SHBET_Promotion Code</p>
            <p className="symbol-text">";</p>
          </div>
          <p className="symbol-text">{"};"}</p>
        </div>
      </div>
    </div>
  );
};

export default Page404;
